import { render, staticRenderFns } from "./FeedSrc.vue?vue&type=template&id=15a95259&scoped=true"
import script from "./FeedSrc.vue?vue&type=script&lang=js"
export * from "./FeedSrc.vue?vue&type=script&lang=js"
import style0 from "./FeedSrc.vue?vue&type=style&index=0&id=15a95259&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a95259",
  null
  
)

export default component.exports